import produce from "immer";

const initialState = {
  product: null,
  userData: null,
  invoice_id: null,
};

export const aboutVideoReducer = produce((state, action) => {
  switch (action.type) {
    case "aboutVideo/getProduct":
      state.product = action.payload;
      break;
    case "aboutVideo/getUserData":
      state.userData = action.payload;
      break;
    case "aboutVideo/setInvoiceID":
      state.invoice_id = action.payload;
      break;
  }
}, initialState);
